import { Reference, Property, Name, Output } from '@components/Reference';
import Sandbox from '@components/Sandbox';
import * as React from 'react';
export default {
  Reference,
  Property,
  Name,
  Output,
  Sandbox,
  React
};